import { GetBaggageDetailsState } from './getBaggageDetails.types'

const initialState: GetBaggageDetailsState = {
  loading: false,
  error: null,
  success: null
  // Initialize any additional state properties here
}

export default initialState
